import React, { useState } from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import {
  Body,
} from "../../screens/Login/Login.styles"

const PasswordPolicy = ({ password }) => {

  // Function to check the password against policy rules
  const validatePassword = (password) => {
    const rules = {
      length: password.length >= 14,
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      upperCase: /[A-Z]/.test(password),
      lowerCase: /[a-z]/.test(password),
      numeric: /[0-9]/.test(password),
      noSpaces: !/\s/.test(password),
      noTripleRepeat: !/(.)\1\1/.test(password),
    };

    return rules;
  };

  // Validate the current password
  const rules = validatePassword(password);

  return (
    <div>
      <Body sx={{fontSize: '18px', color: "#000", mb:0}}>Password Policy:</Body>

      <div>
        <ul style={{ listStyleType: 'none', fontSize: '12px', padding: 0}}>
          <li style={{display: 'flex', alignItems: 'center', marginBottom: '16px'}}>
            {rules.length ? <CheckCircleOutlineIcon sx={{mr: "6px"}} color="success" /> : <CancelOutlinedIcon sx={{mr: "6px"}} color="error"/>}
            Password should be of at least 14 characters
          </li>
          <li style={{display: 'flex', alignItems: 'center', marginBottom: '16px'}}>
            {rules.specialChar ? <CheckCircleOutlineIcon sx={{mr: "6px"}} color="success" /> : <CancelOutlinedIcon sx={{mr: "6px"}} color="error"/>}
            Should contain one special character
          </li>
          <li style={{display: 'flex', alignItems: 'center', marginBottom: '16px'}}>
            {rules.upperCase ? <CheckCircleOutlineIcon sx={{mr: "6px"}} color="success" /> : <CancelOutlinedIcon sx={{mr: "6px"}} color="error"/>}
            Should contain one upper case character
          </li>
          <li style={{display: 'flex', alignItems: 'center', marginBottom: '16px'}}>
            {rules.lowerCase ? <CheckCircleOutlineIcon sx={{mr: "6px"}} color="success" /> : <CancelOutlinedIcon sx={{mr: "6px"}} color="error"/>}
            Should have one lowercase character
          </li>
          <li style={{display: 'flex', alignItems: 'center', marginBottom: '16px'}}>
            {rules.numeric ? <CheckCircleOutlineIcon sx={{mr: "6px"}} color="success" /> : <CancelOutlinedIcon sx={{mr: "6px"}} color="error"/>}
            Should have at least one numeric character
          </li>
        </ul>
        
        <Body sx={{fontSize: '14px', color: "#000"}}>Don'ts</Body>
        <ul style={{ listStyleType: 'none', fontSize: '12px', padding: 0}}>
          <li style={{display: 'flex', alignItems: 'center', marginBottom: '16px'}}>
            {rules.noSpaces ? <CheckCircleOutlineIcon sx={{mr: "6px"}} color="success" /> : <CancelOutlinedIcon sx={{mr: "6px"}} color="error"/> }
            Should not have blank spaces
          </li>
          <li style={{display: 'flex', alignItems: 'center', marginBottom: '16px'}}>
             {rules.noTripleRepeat ? <CheckCircleOutlineIcon sx={{mr: "6px"}} color="success" /> : <CancelOutlinedIcon sx={{mr: "6px"}} color="error"/> }
            Should not have the same character repeated thrice
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PasswordPolicy;
